export default __webpack_public_path__ + "static/media/iconDownload.593e15a4.svg";